module.exports = __webpack_public_path__ + "/login_ui/img/gu-2c9200ac07b69b44244fdb3b1f68bdf3.svg";